import { ProviderLogo as BaseProviderLogo } from "../Casino/ProviderLogo";

export const LiveProviderLogo = {
  ...BaseProviderLogo,

  // Live casino specific
  "absolute": require("../../../assets/img/catalog/fortuna45/AbsoluteGaming.png"),
  "amusnet-live": require("../../../assets/img/catalog/fortuna45/AmusnetGaming.png"),
  "creedroomz": require("../../../assets/img/catalog/fortuna45/CreedroomzGaming.png"),
  "creedroomzP": require("../../../assets/img/catalog/fortuna45/CreedroomzGaming.png"),
  "creedroomz-b": require("../../../assets/img/catalog/fortuna45/CreedroomzGaming.png"),
  "eclipse": require("../../../assets/img/catalog/fortuna45/eclipse.png"),
  "eclipse-b": require("../../../assets/img/catalog/fortuna45/eclipse.png"),
  "eclipseP": require("../../../assets/img/catalog/fortuna45/eclipse.png"),
  "eezecasino": require("../../../assets/img/catalog/fortuna45/Eeze_casinoGaming.png"),
  "evolutionGH": require("../../../assets/img/catalog/fortuna45/EvolutionGaming.png"),
  "evolutionGHHS": require("../../../assets/img/catalog/fortuna45/EvolutionGaming.png"),
  "evolutionGHLS": require("../../../assets/img/catalog/fortuna45/EvolutionGaming.png"),
  "evolutionGHVHS": require("../../../assets/img/catalog/fortuna45/EvolutionGaming.png"),
  "evolutionGHX": require("../../../assets/img/catalog/fortuna45/EvolutionGaming.png"),
  "evolutionGHY": require("../../../assets/img/catalog/fortuna45/EvolutionGaming.png"),
  "ezugiX": require("../../../assets/img/catalog/fortuna45/EzugiGaming.png"),
  "ezugiZ": require("../../../assets/img/catalog/fortuna45/EzugiGaming.png"),
  "ftv": require("../../../assets/img/catalog/fortuna45/ftv.png"),
  "ftv-b": require("../../../assets/img/catalog/fortuna45/ftv.png"),
  "ftvP": require("../../../assets/img/catalog/fortuna45/ftv.png"),
  "iconic21": require("../../../assets/img/catalog/fortuna45/Iconic21Gaming.png"),
  "imagine live": require("../../../assets/img/catalog/fortuna45/ImaginLiveGaming.png"),
  "imagineliveHS": require("../../../assets/img/catalog/fortuna45/ImaginLiveGaming.png"),
  "imagineliveLS": require("../../../assets/img/catalog/fortuna45/ImaginLiveGaming.png"),
  "livegames": require("../../../assets/img/catalog/fortuna45/LiveGames.png"),
  "micro-gaming-live": require("../../../assets/img/catalog/fortuna45/microgaming.png"),
  "onetouch-bj": require("../../../assets/img/catalog/fortuna45/OnetouchGaming.png"),
  "onetouch-live": require("../../../assets/img/catalog/fortuna45/OnetouchGaming.png"),
  "pateplay-live": require("../../../assets/img/catalog/fortuna45/PatePlayGaming.png"),
  "platipus-live": require("../../../assets/img/catalog/fortuna45/PlatipusGaming.png"),
  "popok-live": require("../../../assets/img/catalog/fortuna45/PopOkGaming.png"),
  "pragmatic-bj": require("../../../assets/img/catalog/fortuna45/pragmatic.png"),
  "pragmatic-bj2": require("../../../assets/img/catalog/fortuna45/pragmatic.png"),
  "pragmatic-live": require("../../../assets/img/catalog/fortuna45/pragmatic.png"),
  "religa": require("../../../assets/img/catalog/fortuna45/ReligaGaming.png"),
  "sagaming": require("../../../assets/img/catalog/fortuna45/SAGaming.png"),
  "sexygaming": require("../../../assets/img/catalog/fortuna45/sexygaming.png"),
  "skywind-bj": require("../../../assets/img/catalog/fortuna45/SkyWindgroupGaming.png"),
  "skywind-live": require("../../../assets/img/catalog/fortuna45/SkyWindgroupGaming.png"),
  "tvbet": require("../../../assets/img/catalog/fortuna45/TvBetGaming.png"),
  "vision": require("../../../assets/img/catalog/fortuna45/vision.png"),
  "vision-b": require("../../../assets/img/catalog/fortuna45/vision.png"),
  "visionP": require("../../../assets/img/catalog/fortuna45/vision.png"),
  "7-mojos": require("../../../assets/img/catalog/fortuna45/7mojos.png"),
  "vivolive": require("../../../assets/img/catalog/fortuna45/vivo.png"),

  // GASEA live
  "GASEA_7Mojos": require("../../../assets/img/catalog/fortuna45/7mojosGaming.png"),
  "GASEA_AA_Sexy": require("../../../assets/img/catalog/fortuna45/sexygaming.png"),
  "GASEA_CQ9": require("../../../assets/img/catalog/fortuna45/cq9.png"),
  "GASEA_Evolution_Live": require("../../../assets/img/catalog/fortuna45/evolution_gaming.png"),
  "GASEA_Iconic21": require("../../../assets/img/catalog/fortuna45/Iconic21Gaming.png"),
  "GASEA_Microgaming": require("../../../assets/img/catalog/fortuna45/microgaming.png"),
  "GASEA_YeeBet": require("../../../assets/img/catalog/fortuna45/yeebet.png"),
  "GASEA_Pragmatic_Play": require("../../../assets/img/catalog/fortuna45/pragmatic.png"),
  "GASEA_Big_Time_Gaming": require("../../../assets/img/catalog/fortuna45/BigTimeGaming.png"),
  "GASEA_3Oaks": require("../../../assets/img/catalog/fortuna45/3Oaks_3.png"),
  "GASEA_Netent": require("../../../assets/img/catalog/fortuna45/NetEntGaming.png"),
  "GASEA_NoLimit_City": require("../../../assets/img/catalog/fortuna45/NolimitCityGaming.png"),
  "GASEA_Playson": require("../../../assets/img/catalog/fortuna45/PlaysonGaming.png"),
  "GASEA_Red_Tiger": require("../../../assets/img/catalog/fortuna45/RedTigerGaming.png"),
  "GASEA_Ruby_Play": require("../../../assets/img/catalog/fortuna45/RubyPlayGaming.png"),
  "GASEA_YellowBat": require("../../../assets/img/catalog/gasea/YellowBatGaming.png"),
  "GASEA_Vplus": require("../../../assets/img/catalog/gasea/vplus.png"),
  "GASEA_Thunderkick": require("../../../assets/img/catalog/gasea/GASEA_Thunderkick.png"),
  "GASEA_The_Better_Platform": require("../../../assets/img/catalog/gasea/The_Better_Platform.png"),
  "GASEA_Relax_Gaming": require("../../../assets/img/catalog/gasea/Relax_Gaming.png"),
  "GASEA_KingMidas": require("../../../assets/img/catalog/gasea/kingmidas.png"),
  "GASEA_JDB": require("../../../assets/img/catalog/gasea/JDB.png"),
  "GASEA_GTF": require("../../../assets/img/catalog/gasea/GTF.png"),
  "GASEA_PlayNGo": require("../../../assets/img/catalog/gasea/PlayNGo.png"),
  "GASEA_Lets_Go": require("../../../assets/img/catalog/gasea/Lets_Go.png"),
  "GASEA_DB_Slots": require("../../../assets/img/catalog/gasea/DB_Slots.png"),
  "GASEA_CP_Games": require("../../../assets/img/catalog/gasea/CP_Games.png"),
  "GASEA_CG": require("../../../assets/img/catalog/gasea/CG.png"),
  "GASEA_BNG": require("../../../assets/img/catalog/gasea/BNG.png"),
  "GASEA_AvatarUX": require("../../../assets/img/catalog/gasea/AvatarUX.png"),
  "GASEA_Alize_Slots": require("../../../assets/img/catalog/gasea/Alize_Slots.png"),
  "GASEA_AdvantPlay": require("../../../assets/img/catalog/gasea/AdvantPlay.png"),
  "GASEA_Big_Gaming": require("../../../assets/img/catalog/gasea/Big_Gaming.png"),
  "GASEA_Cockfight6": require("../../../assets/img/catalog/gasea/Cockfight6.png"),
  "GASEA_Crystal": require("../../../assets/img/catalog/gasea/Crystal.png"),
  "GASEA_Winfinity": require("../../../assets/img/catalog/gasea/WinfinityGaming.png"),
  "GASEA_Habanero": require("../../../assets/img/catalog/gasea/habanero.png"),
  "GASEA_KY_Poker": require("../../../assets/img/catalog/gasea/KY_Poker.png"),
  "GASEA_Tada": require("../../../assets/img/catalog/fortuna45/TaDaGaming.png"),
  "elcasino": require("../../../assets/img/catalog/gasea/elcasino.png"),
  "yoriginal-games": require("../../../assets/img/catalog/gasea/yoriginal-games.png"),
  "in-out": require("../../../assets/img/catalog/gasea/in-out.png"),
};
